import type { PublicShareItemSnapshot, QuoteItem } from './types';

export function isReceiptCapableShareItem(
  item: PublicShareItemSnapshot,
): item is QuoteItem {
  return Boolean(
    item.deviceId &&
      item.sourceType &&
      item.sourceId &&
      item.sourceName &&
      typeof item.stock === 'number' &&
      Number.isFinite(item.stock),
  );
}
